<template>
    <div class="detail-overview">
        <div class="overview-basic">
            <div class="basic-item">
                <div class="basic-item_label">需求类型</div>
                <div class="basic-item_value">{{ taskData?.task_type_info?.name }}</div>
            </div>

            <div class="basic-item">
                <div class="basic-item_label">解决方式</div>
                <div class="basic-item_value">{{ taskData?.task_mode === 1 ? "招募" : "竞单" }}</div>
            </div>

            <div class="basic-item">
                <div class="basic-item_label">需求预算</div>
                <div class="basic-item_value money">{{ taskData?.task_budget }}金币</div>
            </div>
        </div>

        <div class="overview-list">
            <div class="overview-item">
                <div class="overview-item_label">需求名称</div>

                <div class="overview-item_value">{{ taskData?.task_name }}</div>
            </div>

            <div class="overview-item">
                <div class="overview-item_label">需求描述</div>

                <div class="overview-item_value" v-for="desc in taskData?.task_description?.split('\n')">
                    {{ desc }}
                </div>
            </div>
        </div>

        <div class="overview-files">
            <div class="file-item" v-for="file in taskData?.task_files" :key="file.file_url">
                <div class="file-item_img flex-center">
                    <img :src="getIcon(file.file_name)" alt="" />
                </div>

                <div class="file-item_info">
                    <div class="info-title">{{ file.file_name }}</div>

                    <div class="info-bottom">
                        <div class="info-size">{{ file.file_size }}</div>

                        <div class="info-operate">
                            <el-button type="text" v-if="isPreviewFile(file.file_name)" @click="handlePreview(file)">预览</el-button>
                            <el-button type="text" @click="handleDownload(file)">下载</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { downloadFile, getFileIcon, getFileUnit, previewFilePath } from "@/utils/common";

export default {
    data() {
        return {};
    },

    props: {
        taskData: {
            type: Object,
        },
    },

    methods: {
        // 获取文件Icon
        getIcon(name) {
            return getFileIcon(getFileUnit(name));
        },

        // 文件是否可进行预览
        isPreviewFile(name) {
            const excludeSuffix = ["zip", "7z"];

            return !excludeSuffix.includes(getFileUnit(name));
        },

        // 下载文件
        async handleDownload(file) {
            downloadFile(file.file_url, file.file_name);
            // try {
            //     await downloadFileByFetch(file.file_url, file.file_name);
            // } catch (error) {
            //     this.$message.error(error);
            // }
        },

        // 预览文件
        async handlePreview(file) {
            const previewPath = await previewFilePath(file.file_url);
            window.open(previewPath, "_blank");
        },
    },
};
</script>

<style lang="scss" scoped>
.detail-overview {
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
    padding: 36px;
    background-color: #ffffff;

    .overview-basic {
        padding-inline: 32px;
        height: 100px;
        background: #ffffff;
        border-radius: 12px;
        border: 1px solid #e4e7f0;
        display: flex;
        align-items: center;

        .basic-item {
            flex: 1;
            font-size: 14px;

            &_label {
                font-weight: 400;
                color: #999999;
            }

            &_value {
                margin-top: 16px;
                font-weight: 500;
                color: #666666;

                &.money {
                    color: #ff8a00;
                }
            }
        }
    }

    .overview-list {
        margin-top: 32px;

        .overview-item {
            & + .overview-item {
                margin-top: 32px;
            }

            &_label {
                font-weight: 500;
                font-size: 16px;
                color: #333333;
                margin-bottom: 10px;
            }

            &_value {
                font-weight: 400;
                font-size: 14px;
                color: #666666;
                line-height: 20px;
            }
        }
    }

    .overview-files {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        margin-top: 80px;

        .file-item {
            box-sizing: border-box;
            width: calc((100% - 32px) / 3);
            height: 72px;
            background-color: #f6f6f6;
            border-radius: 4px;
            padding: 16px 11px 16px;
            display: flex;
            align-items: center;
            gap: 8px;

            &_img {
                height: 40px;
                width: 40px;
                border: 1px solid #eee;

                img {
                    height: 30px;
                    width: 30px;
                    object-fit: cover;
                }
            }

            &_info {
                flex: 1;
                min-width: 0;

                .info-title {
                    font-weight: 500;
                    font-size: 12px;
                    color: #333333;
                }

                .info-bottom {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    height: 24px;

                    .info-size {
                        font-weight: 500;
                        font-size: 12px;
                        color: #999999;
                    }
                }
            }
        }
    }
}
</style>
